import React, { useState, useEffect, useRef } from 'react';
import CreatableSelect from 'react-select/creatable';
import Select, { createFilter } from 'react-select';
import axios from 'axios';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { submitInsertWithVariations } from './submitInsertWithVariations';



const CustomInsertIntoCardName = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.CreateCardForm[key]?.[currentLang] || key;
  const [cardName,setCardName] = useState([]);
  const [variation, setVariation] = useState([]);
  const [filteredCardVariation, setFilteredCardVariation] = useState([]);
  const [newVariationName, setNewVariationName] = useState(null);
  const [newVariation, setNewVariation] = useState(null);
  const [testisLoading, setTestIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    IsRookie: false,
    IsPatch: false,
    IsJersey: false,
    IsAuto: false,
    IsTribute: false,
    Numbered: '',
    fromSet:''
  });

  const selectRefs = {
    variationName: useRef(null),
    variation: useRef(null),
  };
  const ToggleButton = ({ label, name, value, onChange, disabled,tabindex }) => {
    const handleClick = () => {
      if (!disabled) {
        onChange(name, !value);
      }
    };

    return (
      <button
        type="button"
        className={`toggle-button ${value ? "active" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={handleClick}
        disabled={disabled} // This will apply the native HTML disabled attribute
        aria-pressed={value}
        tabIndex={tabindex}
      >
        {t(label)}
      </button>
    );
  };
  useEffect(() => {
    if (newVariationName?.value) {
      const filtered = variation.filter(v => parseInt(v.name) === parseInt(newVariationName.value));
      setFilteredCardVariation(filtered);
    }
  }, [newVariationName]);


  useEffect(() => {
    fetchCardVariationOptions();
    fetchCardOptions();
  }, []);

  
    const fetchCardOptions = async () => {
      try {
        const response = await axios.get(
         `${process.env.REACT_APP_API_BASE}/api/variation/getCard`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
        );
        const getCards = response.data.map((getCard) => ({
          value: getCard.IdCardVariation,
          label: getCard.cardName,
          name: getCard.fromSet,
        }));
  
        setCardName(getCards);
      } catch (error) {
        console.log("Error fetching set options:", error.message);
      }
    };
 const fetchCardVariationOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCardVariation`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );
      const variations = response.data.map((variation) => ({
        value: variation.IDVariation,
        label: variation.variationName,
        name: variation.IdCardVariation,
        isAuto: variation.isAuto,
        isPatch: variation.isPatch,
        numbered: variation.numbered,
        isRookie: variation.isRookie,
        isJersey: variation.isJersey,
      }));

      setVariation(variations);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };


  const fetchSuggestions = async (inputValue, type) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${type}?searchTerm=${inputValue}`,
      {
        withCredentials: true, // ✅ sends cookies/session
      });
      const suggestions = response.data.map(item => ({
        value: item.IdCardVariation,
        label: item.cardName,
        name: item.fromSet
      }));
      setVariation(suggestions);
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  };

  const handleCardInputChange = (inputValue) => {
    if (inputValue.length >= 3) fetchSuggestions(inputValue, 'card');
  };

  const handleCreateVariationName = (inputValue) => {
    const newOption = { value: 0, label: inputValue, name: 'manual' };
    setNewVariationName(newOption);
    setNewVariation({ value: 'Base', label: 'Base' });
  };

  const handleCreateVariation = (inputValue) => {
    const newOption = { value: 0, label: inputValue, name: 'manual' };
    setNewVariation(newOption);
  };

  const handleChangeVariationName = (selected) => {
    setNewVariationName(selected);
  };

  const handleChangeVariation = (selected) => {
    setNewVariation(selected);
  };

  const handleToggleButtonChange = (name) => {
    setFormData(prev => ({ ...prev, [name]: !prev[name] }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };



  const TheCupInsertTemplates = [
    {
      cardName: '(RPA)Rookie Patch Auto',
      variations: [
        { variationName: '/249', isAuto: 1, isPatch: 1, numbered: 249, isRookie: 1, isJersey: 0 },
        { variationName: 'Gold /12', isAuto: 1, isPatch: 1, numbered: 12, isRookie: 1, isJersey: 0 },
        { variationName: 'Gold /24', isAuto: 1, isPatch: 1, numbered: 24, isRookie: 1, isJersey: 0 },
        { variationName: 'Platinum 1/1', isAuto: 1, isPatch: 1, numbered: 1, isRookie: 1, isJersey: 0 },
        { variationName: 'Shield 1/1', isAuto: 1, isPatch: 1, numbered: 1, isRookie: 1, isJersey: 0 },
        { variationName: 'Button /3', isAuto: 1, isPatch: 1, numbered: 3, isRookie: 1, isJersey: 0 },
        { variationName: 'Tag /3', isAuto: 1, isPatch: 1, numbered: 3, isRookie: 1, isJersey: 0 }
      ]
    },
 
    {
      cardName: 'Rookie Masterpieces',
      variations: [
        { variationName: 'Black 1/1', isAuto: 1, isPatch: 0, numbered: 1, isRookie: 1, isJersey: 0 },
        { variationName: 'Cyan 1/1', isAuto: 1, isPatch: 0, numbered: 1, isRookie: 1, isJersey: 0 },
        { variationName: 'Magenta 1/1', isAuto: 1, isPatch: 0, numbered: 1, isRookie: 1, isJersey: 0 },
        { variationName: 'Yellow 1/1', isAuto: 1, isPatch: 0, numbered: 1, isRookie: 1, isJersey: 0 }
      ]
    },
    {
        cardName: 'Rookie Class of',
        variations: [
          { variationName: 'Auto /249', isAuto: 1, isPatch: 0, numbered: 249, isRookie: 1, isJersey: 0 }
        ]
      },
    {
      cardName: 'Stanley Cup Signatures',
      variations: [
        { variationName: 'Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 },
        { variationName: 'Dual Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 },
        { variationName: 'Triple Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 },
        { variationName: 'Artist Proof /1', isAuto: 1, isPatch: 0, numbered: 1, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Stanley Cup Titlists',
      variations: [
        { variationName: 'Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 },
        { variationName: 'Patch Auto', isAuto: 1, isPatch: 1, numbered: 0, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Cup Foundations',
      variations: [
        { variationName: 'Quad Jersey /25', isAuto: 0, isPatch: 0, numbered: 25, isRookie: 0, isJersey: 1 },
        { variationName: 'Quad Jersey Auto /15', isAuto: 1, isPatch: 0, numbered: 15, isRookie: 0, isJersey: 1 },
        { variationName: 'Quad Patch /5', isAuto: 0, isPatch: 1, numbered: 5, isRookie: 0, isJersey: 0 },
        { variationName: 'Quad Patch Auto /5', isAuto: 1, isPatch: 1, numbered: 5, isRookie: 0, isJersey: 0 },
        { variationName: 'Stick Auto /3', isAuto: 1, isPatch: 0, numbered: 3, isRookie: 0, isJersey: 0 },
        { variationName: 'Tag Auto /1', isAuto: 1, isPatch: 1, numbered: 1, isRookie: 0, isJersey: 0 },
        { variationName: 'Artist Proof Jersey /1', isAuto: 0, isPatch: 0, numbered: 1, isRookie: 0, isJersey: 1 },
        { variationName: 'Artist Proof Patch /1', isAuto: 0, isPatch: 1, numbered: 1, isRookie: 0, isJersey: 0 }
      ]
    },
    {
        cardName: 'Rookie Cup Foundations',
        variations: [
          { variationName: 'Quad Jersey /25', isAuto: 0, isPatch: 0, numbered: 25, isRookie: 1, isJersey: 1 },
          { variationName: 'Quad Jersey Auto /15', isAuto: 1, isPatch: 0, numbered: 15, isRookie: 1, isJersey: 1 },
          { variationName: 'Quad Patch /5', isAuto: 0, isPatch: 1, numbered: 5, isRookie: 1, isJersey: 0 },
          { variationName: 'Quad Patch Auto /5', isAuto: 1, isPatch: 1, numbered: 5, isRookie: 1, isJersey: 0 },
          { variationName: 'Stick Auto /3', isAuto: 1, isPatch: 0, numbered: 3, isRookie: 1, isJersey: 0 },
          { variationName: 'Tag Auto /1', isAuto: 1, isPatch: 1, numbered: 1, isRookie: 1, isJersey: 0 },
          { variationName: 'Artist Proof Jersey /1', isAuto: 0, isPatch: 0, numbered: 1, isRookie: 1, isJersey: 1 },
          { variationName: 'Artist Proof Patch /1', isAuto: 0, isPatch: 1, numbered: 1, isRookie: 1, isJersey: 0 }
        ]
      },
    {
      cardName: 'Signature Patches',
      variations: [
        { variationName: 'Patch Auto /75', isAuto: 1, isPatch: 1, numbered: 75, isRookie: 0, isJersey: 0 },
        { variationName: 'Gold Patch Auto /25', isAuto: 1, isPatch: 1, numbered: 25, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Enshrinements',
      variations: [
        { variationName: 'Auto /99', isAuto: 1, isPatch: 0, numbered: 99, isRookie: 0, isJersey: 0 },
        { variationName: 'Dual Auto /25', isAuto: 1, isPatch: 0, numbered: 25, isRookie: 0, isJersey: 0 },
        { variationName: 'Triple Auto /10', isAuto: 1, isPatch: 0, numbered: 10, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Scripted Swatches',
      variations: [
        { variationName: 'Patch Auto /35', isAuto: 1, isPatch: 1, numbered: 35, isRookie: 0, isJersey: 0 },
        { variationName: 'Gold Patch Auto /25', isAuto: 1, isPatch: 1, numbered: 25, isRookie: 0, isJersey: 0 }
      ]
    },
    {
        cardName: 'Dual Scripted Swatches',
        variations: [
          { variationName: 'Dual Patch Auto /5', isAuto: 1, isPatch: 1, numbered: 5, isRookie: 0, isJersey: 0 }
        ]
      },
    {
      cardName: 'Scripted Sticks',
      variations: [
        { variationName: 'Stick Auto /15', isAuto: 1, isPatch: 0, numbered: 15, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Signature Renditions',
      variations: [
        { variationName: 'Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Program of Excellence',
      variations: [
        { variationName: 'Auto /10', isAuto: 1, isPatch: 0, numbered: 10, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Limited Logos',
      variations: [
        { variationName: 'Patch Auto /50', isAuto: 1, isPatch: 1, numbered: 50, isRookie: 0, isJersey: 0 },
        { variationName: 'Gold Patch Auto /10', isAuto: 1, isPatch: 1, numbered: 10, isRookie: 0, isJersey: 0 }
      ]
    },
    {
      cardName: 'Brilliance',
      variations: [
        { variationName: 'Auto', isAuto: 1, isPatch: 0, numbered: 0, isRookie: 0, isJersey: 0 }
      ]
    },
    {
        cardName: 'Honorable Numbers',
        variations: [
          { variationName: 'Patch Auto (Player Numbered)', isAuto: 1, isPatch: 1, numbered: 0, isRookie: 0, isJersey: 0 }
        ]
      },
      {
        cardName: 'Rookie Honorable Numbers',
        variations: [
          { variationName: 'Patch Auto (Player Numbered)', isAuto: 1, isPatch: 1, numbered: 0, isRookie: 1, isJersey: 0 }
        ]
      },
      {
        cardName: 'Cup Trios',
        variations: [
          { variationName: 'Triple Patch /10', isAuto: 0, isPatch: 1, numbered: 10, isRookie: 0, isJersey: 0 },
          { variationName: 'Triple Patch Auto /5', isAuto: 1, isPatch: 1, numbered: 5, isRookie: 0, isJersey: 0 }
        ]
      },
      {
        cardName: 'Cup Quads',
        variations: [
          { variationName: 'Quad Jersey /10', isAuto: 0, isPatch: 0, numbered: 10, isRookie: 0, isJersey: 1 },
          { variationName: 'Quad Patch /5', isAuto: 0, isPatch: 1, numbered: 5, isRookie: 0, isJersey: 0 }
        ]
      },
      {
        cardName: 'Base',
        variations: [
          { variationName: '/249', isAuto: 0, isPatch: 0, numbered: 249, isRookie: 0, isJersey: 0 },
          { variationName: 'Gold Spectrum /25', isAuto: 0, isPatch: 0, numbered: 25, isRookie: 0, isJersey: 0 },
          { variationName: 'Platinum 1/1', isAuto: 0, isPatch: 0, numbered: 1, isRookie: 0, isJersey: 0 }
        ]
      },
      {
        cardName: 'Base Auto',
        variations: [
          { variationName: 'Auto /99', isAuto: 1, isPatch: 0, numbered: 99, isRookie: 0, isJersey: 0 },
          { variationName: 'Gold Auto /12', isAuto: 1, isPatch: 0, numbered: 12, isRookie: 0, isJersey: 0 }
        ]
      }
  ];








  






















































































































  const setsToInsert = [
    { SetName: "2023-24 Upper Deck Artifacts", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Allure", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Black Diamond", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Credentials", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Ice", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Trilogy", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Synergy", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Ultimate Collection", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Upper Deck Premier", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 O-Pee-Chee", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 SkyBox Metal Universe", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 SP Authentic", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 SPx", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 SP Game Used", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Clear Cut", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Tim Hortons", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 Parkhurst", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2023-24 SP Signature Edition Legends", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Upper Deck MVP", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 O-Pee-Chee", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Parkhurst", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 SkyBox Metal Universe", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Tim Hortons", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Upper Deck", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 SP Signature Edition Legends", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Artifacts", TypeSet: "Hockey", isValidate: 1 },
    { SetName: "2024-25 Trilogy", TypeSet: "Hockey", isValidate: 1 }
  ];
  
 
  const families = [
    'Allure', 'Artifacts', 'Black Diamond', 'Chronology', 'Clear Cut', 'Credentials',
    'Engrained', 'Fleer Showcase', 'Ice', 'MVP', 'Metal Universe', 'Parkhurst Modern',
    'Parkhurst Vintage', 'Platinum', 'Premier', 'S1-S2-SPA', 'SP Authentic',
    'SP Game Used', 'SP Signature Edition Legends', 'SPx', 'Stature', 'Synergy',
    'The Cup', 'Trilogy', 'Ultimate Collection', 'Upper Deck Series 1/2', 'Victory'
  ];
  

  async function submitset_families(families) {
    try {
      const response = 
      await fetch(`${process.env.REACT_APP_API_BASE}/api/add/InsertFamilies`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ families })
      });
  
      const result = await response.json();
  
      if (!response.ok) {
        console.error('Error inserting sets:', result);
        return { success: false, error: result };
      }
  
      console.log('Sets inserted successfully:', result);
      return { success: true, result };
  
    } catch (error) {
      console.error('Request failed:', error);
      return { success: false, error };
    }
  }




 








  async function insertAllSPAuthentic() {
    const fromSet = 'SP Signatures Legends';
    const inserts = []
     
    
    
    
    
    
    
      
    
         // You’ll fill this with SPAInsertTemplates
  
    for (const insert of inserts) {
      const result = await submitInsertWithVariations(
        insert.cardName,
        fromSet,
        0,
        insert.variations
      );
  
      if (result.success) {
        console.log(`✅ Inserted: ${insert.cardName}`);
      } else {
        console.error(`❌ Failed: ${insert.cardName}`, result.error);
      }
    }
  }






  const triggerSubmit = async () => {
    // if (!newVariationName || !newVariation) {
    //   console.error("Missing required fields: cardName or variation");
    //   return;
    // }
  
    try {
  console.log('je commence insert into insertAllSPAuthentic')
        //insertAllSPAuthentic();
      //  await submitset_families(families);
        console.log('jai fini insert into insertAllSPAuthentic')
    //   // Step 1: Insert new Card Name if it does not exist
    //   let IdCardVariation = newVariationName.value;
    //   if (IdCardVariation === 0) {
    //     const cardResponse = await axios.post(
    //       "https://projet-collect-v1-production.up.railway.app/api/add/NewVariationNameFromSet",
    //       { cardName: newVariationName.label,
    //         fromSet: formData.fromSet
    //        }
    //     );
    //     IdCardVariation = cardResponse.data;
    //     console.log('insert NewVariationName',newVariationName.label,' from',formData.fromSet )
    //   }
  
    //   // Step 2: Insert new Variation if it does not exist
    //   let IDVariation = newVariation.value;
    //   if (IDVariation === 0) {
    //     const variationData = {
    //     //   IdCardVariation,
          
    //       variationName: newVariation.label,
    //       //IdSet: "TBD", // Modify this if needed
    //       isAuto: formData.IsAuto ? 1 : 0,
    //       isPatch: formData.IsPatch ? 1 : 0,
    //       numbered: formData.Numbered ? parseInt(formData.Numbered, 10) || 0 : 0,
    //       isRookie: formData.IsRookie ? 1 : 0,
    //       isJersey: formData.IsJersey ? 1 : 0,
    //     };
  
    //     const variationResponse = await axios.post(
    //       "https://projet-collect-v1-production.up.railway.app/api/add/Variation",
    //       variationData
    //     );
    //     IDVariation = variationResponse.data;
    //     console.log('insert IDVariation',variationData )
     
    //   }
  
    //   console.log("Successfully inserted card name and variation:", {
    //     IdCardVariation,
    //     IDVariation,
    //   });
      
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  

  const stylingSelect = {
    control: (base) => ({ ...base, backgroundColor: '#222', color: 'white' }),
    menu: (base) => ({ ...base, backgroundColor: '#222' }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? '#0066FFED' : '#222',
      color: 'white'
    })
  };

  return (
    <section className="grid">
      <div className="contentfront">
        <div className='flex-h'>
        <div className="form-group" style={{minHeight:'20vh'}}>
          <label>ex : Young Guns</label>
          <CreatableSelect
            placeholder={t("Select the card Name")}
            isClearable
            ref={selectRefs.variationName}
            isDisabled={testisLoading}
            isLoading={testisLoading}
            onChange={handleChangeVariationName}
            onCreateOption={handleCreateVariationName}
            options={cardName}
            value={newVariationName}
            className="custom-select"
            styles={stylingSelect}
            filterOption={createFilter({ ignoreAccents: false })}
            onInputChange={handleCardInputChange}
          />
        </div>
        <div className="form-group">
        <label>ex : HighGloss - ClearCut</label>
        
          <CreatableSelect
            placeholder={t("Select the variation")}
            ref={selectRefs.variation}
            isClearable
            isDisabled={testisLoading}
            isLoading={testisLoading}
            onChange={handleChangeVariation}
            onCreateOption={handleCreateVariation}
            options={filteredCardVariation}
            value={newVariation}
            className="custom-select"
            styles={stylingSelect}
            filterOption={createFilter({ ignoreAccents: false })}
          />
        </div>
        </div>
       
        <div className="flex-h gap" style={{ paddingBottom: '0px',marginBottom:'5vh' }}>
          <ToggleButton
            label="Rookie (RC)"
            name="IsRookie"
            value={formData.IsRookie}
            onChange={() => handleToggleButtonChange("IsRookie")}
          />
          <ToggleButton
            label="Patch"
            name="IsPatch"
            value={formData.IsPatch}
            onChange={() => handleToggleButtonChange("IsPatch")}
          />
          <ToggleButton
            label="Jersey"
            name="IsJersey"
            value={formData.IsJersey}
            onChange={() => handleToggleButtonChange("IsJersey")}
          />
          <ToggleButton
            label="Auto"
            name="IsAuto"
            value={formData.IsAuto}
            onChange={() => handleToggleButtonChange("IsAuto")}
          />
     
          <input
            type="text"
            name="Numbered"
            placeholder={`${t("Numbered")}: /???`}
            value={formData.Numbered}
            onChange={handleInputChange}
            className="form-control"
            style={{ width: '7vw' }}
          />
          

             
          <input
            type="text"
            name="fromSet"
            placeholder={"FromSet"}
            value={formData.fromSet}
            onChange={handleInputChange}
            className="form-control"
            style={{ width: '7vw' }}
          />
        </div>
        <button className='btn-baseBlue' style={{gridColumn:'span 12',marginTop:'15px'}} onClick={triggerSubmit}>submit</button>
      </div>
    </section>
  );
};

export default CustomInsertIntoCardName;
